// Entry point for the build script in your package.json
import "bootstrap/dist/js/bootstrap.bundle"
import Rails from "@rails/ujs"
Rails.start()
import jquery from "jquery"
window.jQuery = jquery
window.$ = jquery
require("./src/bootstrap-multiselect")
require("./src/user-agent-timezone")
require("./src/sortable-table")
